import type { IconProps } from '.';

/**
 * Login Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const LoginIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M12 4C11.0717 4 10.1815 4.36875 9.52513 5.02513C8.86875 5.6815 8.5 6.57174 8.5 7.5C8.5 8.42826 8.86875 9.3185 9.52513 9.97487C10.1815 10.6313 11.0717 11 12 11C12.9283 11 13.8185 10.6313 14.4749 9.97487C15.1313 9.3185 15.5 8.42826 15.5 7.5C15.5 6.57174 15.1313 5.6815 14.4749 5.02513C13.8185 4.36875 12.9283 4 12 4ZM7.5 7.5C7.5 6.30653 7.97411 5.16193 8.81802 4.31802C9.66193 3.47411 10.8065 3 12 3C13.1935 3 14.3381 3.47411 15.182 4.31802C16.0259 5.16193 16.5 6.30653 16.5 7.5C16.5 8.69347 16.0259 9.83807 15.182 10.682C14.3381 11.5259 13.1935 12 12 12C10.8065 12 9.66193 11.5259 8.81802 10.682C7.97411 9.83807 7.5 8.69347 7.5 7.5ZM7.5 15C6.57174 15 5.6815 15.3687 5.02513 16.0251C4.36875 16.6815 4 17.5717 4 18.5V21H3V18.5C3 17.3065 3.47411 16.1619 4.31802 15.318C5.16193 14.4741 6.30653 14 7.5 14H16.5C17.6935 14 18.8381 14.4741 19.682 15.318C20.5259 16.1619 21 17.3065 21 18.5V21H20V18.5C20 17.5717 19.6313 16.6815 18.9749 16.0251C18.3185 15.3687 17.4283 15 16.5 15H7.5Z"
      fill="white"
    />
  </svg>
);

export default LoginIcon;
